import {CompanyDepartmentsResponse} from '../../features/company/profile/types';

export const handleCompanyDepartmentsOptions = (
  companyDepartments: CompanyDepartmentsResponse['companyDepartments'],
  currentLanguage: string | null
) => {
  return companyDepartments?.map((department) => {
    return {
      id: department.resourceId,
      label:
        department?.name[currentLanguage as 'en' | 'de']?.charAt(0)?.toUpperCase() +
        department?.name[currentLanguage as 'en' | 'de']?.slice(1),
    };
  });
};
